export default {"src":"/login-app/[GIT_HASH]/_next/static/media/calendar.2b80e5e8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};